import React, { Component } from "react";
import {NavLink} from "react-router-dom";

export default class NotFound extends Component {
	render() {
		return (
			<div className="hero is-dark is-fullheight">
				<div className="hero-body">
					<div className="container">
						<h1 className="title">404</h1>
						<h2 className="subtitle">No pudimos encontrar la página que buscas</h2>
						<p>Puedes regresar al <NavLink to="/" className="has-text-inm-purple">Inicio</NavLink> y volver a intentar.</p>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/layouts/notfound.jsx